module.exports = __webpack_public_path__ + "img/promo.afa00d94.jpg";